import { render, staticRenderFns } from "./CustomerRelation.vue?vue&type=template&id=73428490&scoped=true"
import script from "./CustomerRelation.vue?vue&type=script&lang=js"
export * from "./CustomerRelation.vue?vue&type=script&lang=js"
import style0 from "./CustomerRelation.vue?vue&type=style&index=0&id=73428490&prod&lang=scss&scoped=true"
import style1 from "./CustomerRelation.vue?vue&type=style&index=1&id=73428490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73428490",
  null
  
)

export default component.exports